module.exports = __webpack_public_path__ + "img/verify.77ce60af.svg";